import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { IComplianceProps } from "../../../leap-components/Compliance/IComplianceProps";
import { Column } from "react-table";
import EpaCard from "../../../leap-components/EpaCard";
import { Grid } from "../../../leap-components/Grid";
import { ILicenceVersion } from "../../../api/LicenceVersion";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import { GetLicenceVersionUrl } from "../../../external-apps/Config";

const RegNoCellFactory = (licenceProfile: ILicenceProfile) => {
  return (rowInfo: any) => {
    const licence = rowInfo.row.original as ILicenceVersion;
    const licenceUrl = GetLicenceVersionUrl(
      licence.licence_type,
      licenceProfile.profileNo,
      licence.licence_id,
      licence.reg_no
    );

    return (
      <a href={licenceUrl} style={{ cursor: "pointer" }}>
        {licence.reg_no}
      </a>
    );
  };
};

const LicenceVersionsGrid = ({ licenceProfile }: IComplianceProps) => {
  const tableColumnsBig: Column<Record<string, ILicenceVersion>>[] = [
    {
      Header: "Reg No.",
      accessor: "reg_no",
      Filter: false,
      Cell: RegNoCellFactory(licenceProfile),
    },
    {
      Header: "Status",
      accessor: "licence_status",
      Filter: false,
    },
    {
      Header: "Sub-Status",
      accessor: "licence_substatus",
      Filter: false,
    },
    {
      Header: "Authorised Date",
      accessor: "date_of_licence",
      Filter: false,
    },
  ];

  const tableColumnsSmall: Column<Record<string, ILicenceVersion>>[] = [
    {
      Header: "Reg No.",
      accessor: "reg_no",
      Filter: false,
      Cell: RegNoCellFactory(licenceProfile),
    },
    {
      Header: "Status",
      accessor: "licence_status",
      Filter: false,
    },
    {
      Header: "Sub-Status",
      accessor: "licence_substatus",
      Filter: false,
    },
    {
      Header: "Authorised Date",
      accessor: "date_of_licence",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={licenceProfile.licenceVersionsList.list}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={licenceProfile.licenceVersionsList.list}
        />
      </div>
    </div>
  );

  return <EpaCard title={""} content={bodyElements} />;
};

const LicenceVersionsTab = () => {
  const [loading, setLoading] = useState(false);
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const dispatch = useAppDispatch();

  let { profileNo } = useParams();
  if (!profileNo) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  const contentElement = (
    <LicenceVersionsGrid licenceProfile={licenceProfile} />
  );

  return (
    <div>
      <BreadCrumbs licenceProfile={licenceProfile} />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="licence-versions"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default LicenceVersionsTab;
